import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map, startWith, switchMap, take } from 'rxjs/operators';

import { ContentAPIService } from '@modules/content-api/content-api.service';

import { LegalAdapter, LegalPage, LegalPageKey } from './legal.adapter';

const LEGAL_PAGE_SORT_ORDER: LegalPageKey[] = [
  'provider',
  'legal-notice',
  'privacy-statement',
  'settings',
  'terms-of-use',
  'accessibility',
];

@Injectable({
  providedIn: 'root',
})
export class LegalService {
  private apiService = inject(ContentAPIService);
  private legalAdapter = inject(LegalAdapter);
  private translateService = inject(TranslateService);

  public legalPages$: Observable<LegalPage[]>;

  constructor() {
    this.legalPages$ = this.translateService.onLangChange.pipe(
      startWith(this.getLegalPages()),
      switchMap(() => this.getLegalPages())
    );
  }

  private getLegalPages(): Observable<LegalPage[]> {
    return this.apiService.getResources('static_pages', { 'filter[page_type]': `legal` }).pipe(
      take(1),
      map((data: any) => {
        // Settings page is locally generated via (CMM UI)
        data.push({
          id: 'settings',
          title: this.translateService.instant('LEGAL_CONSENT_SETTINGS'),
          body: '',
          url_slug: 'settings',
        });
        return data;
      }),
      map((data) => data.map((item: any) => this.legalAdapter.parse(item))),
      map((data: LegalPage[]) =>
        data.sort((a, b) => LEGAL_PAGE_SORT_ORDER.indexOf(a.slug) - LEGAL_PAGE_SORT_ORDER.indexOf(b.slug))
      ),
      catchError(() => {
        return of([]);
      })
    );
  }
}
